export default "__VITE_ASSET__4869c709__"